import { InspirationType } from './types';

export default function getInspirationUrl(inspiration: InspirationType): string {
  return `${inspiration.releaseDate.split('T')[0]}/${inspiration.normalizedTitle}/`;
}
